module.exports = __webpack_public_path__ + "static/media/file-upload.6924e297.svg";